
$(document).foundation();

jQuery(document).ready(function() { 
    $('.hidden-to-start').removeClass('hidden-to-start');
});

$(document)
.on('change', '#sorting-form #model_id, #all-data-form #model_id', function() {
    $('#SKU').val('');
    $('#webcam').attr('checked', false);
});

$('select.select2').each(function() {
    if (!$(this).hasClass('ajax')) {
        $(this).select2();
    }
});

$('form[disable-submit-on-enter], form.disable-submit-on-enter, input.disable-enter-keypress, textarea#comment').on('keyup keypress', function(e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
        e.preventDefault();
        return false;
    }
});

Vue.directive('select2', {
    twoWay: true,
    priority: 1000,

    params: ['options'],

    bind: function () {
        var self = this;
        if (!$(this.el).hasClass('ajax')) {

            $(this.el)
            .select2({
                data: this.params.options
            })
            .on('change', function () {
                self.set($(self.el).val())
            });

        } else {

            $(this.el).select2({
                data: this.params.options,
                placeholder: 'Enter model name to search',
                data: this.params.options,
                ajax: {
                    url: $(this.el).attr('data-search-route'),
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            string: params.term, // search term
                            page: params.page,
                        };
                    },
                    processResults: function (data, params) {
                        // var mockResults = [{id: 1,text: "Option 1"}, {id: 2,text: "Option 2"}, {id: 3,text: "Option 3"}];
                        // return {
                        //     results: mockResults
                        // };
                        return {
                            results: data.results
                        };
                    },
                },
                escapeMarkup: function (markup) { return markup; },
                minimumInputLength: 1
                // ,
                // formatResult: function(item) {
                //     console.log(item);
                //     var markup = "";
                //     if (item.name !== undefined) {
                //         markup += "<option value='" + item.id + "'>" + item.name + "</option>";
                //     }
                //     return markup;
                // },
                // formatSelection: function(item) {
                //     return item.name;
                // }
            })
            .on('change', function () {
                self.set($(self.el).val())
            });

        }
    },
    update: function (value) {
        $(this.el).val(value).trigger('change')
    },
    unbind: function () {
        $(this.el).off().select2('destroy')
    }

});

var initSelect2 = function(element, data) {
    element.select2({
        data: this.params.options,
        placeholder: 'Enter model name to search',
        ajax: {
            url: $(this.el).attr('data-search-route'),
            dataType: 'json',
            delay: 250,
            data: function (params) {
                return {
                    string: params.term, // search term
                    page: params.page,
                };
            },
            processResults: function (data, params) {
                params.page = params.page || 1;

                    destroySelect2(element);
                    initSelect2(element, data.results);
                return {
                    results: data.results,
                    pagination: {
                        more: (params.page * 30) < data.total_count
                    }
                };
            },
        },
        escapeMarkup: function (markup) { return markup; },
        minimumInputLength: 1,
        formatResult: function(item) {
            //console.log(item);
            var markup = "";
            if (item.name !== undefined) {
                markup += "<option value='" + item.id + "'>" + item.name + "</option>";
            }
            return markup;
        },
        formatSelection: function(item) {
            return item.name;
        }
    })
    .on('change', function () {
        self.set($(self.el).val())
    });
}

var destroySelect2 = function(element) {
    element.select2('destroy');
}


jQuery(document).ready(function($) {

    $('.fdatepicker').fdatepicker();

    var openWarningModal = function() {
        if ($('#assetWarningModal .warning-text').length>0) {
            $('.reveal-overlay').addClass('open');
        }
    }
    openWarningModal();
    $(document)
    .on('click', '.close-reveal-modal', function() {
        $('.reveal-overlay').fadeOut(500, function() {
            $(this).removeClass('open');
        });
    })
    .on('click', '.ams-close-obs', function() {
        $(this).closest('.obs-warning').fadeOut(500, function() {
            $('.hidden-on-load').fadeIn(0).removeClass('hidden-on-load');
        });
    });

});

new Vue( {
    el: '#customer-portal-reporting',
    data: {
        include_daughter_companies: "{{ \Request::get('include_daughter_companies') }}"
    }
} );